import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-3" }
const _hoisted_2 = { class: "flex justify-start items-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "leading-17" }
const _hoisted_5 = { class: "flex items-center justify-end" }
const _hoisted_6 = {
  key: 2,
  class: "flex justify-start items-center"
}
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "leading-6 mb-6 w-176" }
const _hoisted_9 = {
  key: 0,
  class: "inline-flex items-center justify-start leading-6 py-2"
}
const _hoisted_10 = { class: "font-bold mr-1" }
const _hoisted_11 = { class: "flex justify-left h-full" }
const _hoisted_12 = { class: "relative wrap h-full" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "border-l absolute border-light-3 border left-4 top-4 bottom-12" }, null, -1)
const _hoisted_14 = { class: "mb-3 flex justify-start items-center w-full right-timeline" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "z-10 flex items-center bg-light-2 w-8 h-8 rounded-full mr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mx-auto font-bold text-xs" }, "1")
], -1)
const _hoisted_16 = { class: "flex justify-between items-center bg-light-1 rounded-lg w-125 px-6 py-2 rounded-md border border-light-1" }
const _hoisted_17 = { class: "flex justify-start items-center" }
const _hoisted_18 = { class: "text-sm font-bold w-28 leading-9" }
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = { class: "mb-3 flex justify-start items-center w-full right-timeline" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "z-10 flex items-center bg-light-2 w-8 h-8 rounded-full mr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mx-auto font-bold text-xs" }, "2")
], -1)
const _hoisted_22 = { class: "flex justify-between items-center bg-light-3 rounded-lg w-125 px-6 py-2 rounded-md border border-light-3" }
const _hoisted_23 = { class: "flex justify-start items-start flex-1" }
const _hoisted_24 = { class: "text-sm font-bold w-28 leading-9" }
const _hoisted_25 = {
  key: 0,
  class: "text-sm leading-9"
}
const _hoisted_26 = {
  key: 1,
  class: "flex flex-col flex-1"
}
const _hoisted_27 = { class: "w-68 mt-1.5" }
const _hoisted_28 = { class: "my-4" }
const _hoisted_29 = { class: "mb-3 flex justify-start items-center w-full right-timeline" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "z-10 flex items-center bg-light-2 w-8 h-8 rounded-full mr-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mx-auto font-bold text-xs" }, "3")
], -1)
const _hoisted_31 = { class: "flex justify-between items-center bg-light-1 rounded-lg w-125 px-6 py-2 rounded-md border border-light-1" }
const _hoisted_32 = { class: "flex justify-start items-center" }
const _hoisted_33 = { class: "text-sm font-bold w-28 leading-9" }
const _hoisted_34 = { class: "text-sm" }
const _hoisted_35 = {
  key: 0,
  class: "leading-6 py-2"
}
const _hoisted_36 = {
  key: 1,
  class: "flex-col justify-start items center"
}
const _hoisted_37 = { class: "text-sm" }
const _hoisted_38 = { class: "flex justify-start mt-4" }
const _hoisted_39 = { class: "text-sm text-dark-3 mt-3 w-100" }
const _hoisted_40 = { class: "mt-8" }
const _hoisted_41 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_42 = { class: "text-sm font-bold leading-4" }
const _hoisted_43 = { class: "text-sm font-normal leading-4 mt-2" }
const _hoisted_44 = {
  key: 1,
  class: "flex-col justify-start items center"
}
const _hoisted_45 = { class: "text-sm" }
const _hoisted_46 = { class: "flex flex-col justify-start mt-4" }
const _hoisted_47 = { class: "mt-8" }
const _hoisted_48 = { class: "hidden md:flex flex-1" }
const _hoisted_49 = { class: "flex flex-col" }
const _hoisted_50 = {
  key: 0,
  class: "py-2"
}
const _hoisted_51 = {
  key: 0,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_52 = { class: "font-bold" }
const _hoisted_53 = {
  key: 1,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_54 = { class: "font-bold" }
const _hoisted_55 = {
  key: 2,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_56 = { class: "font-bold" }
const _hoisted_57 = {
  key: 3,
  class: "inline-block mr-2 text-sm leading-6"
}
const _hoisted_58 = { class: "font-bold" }
const _hoisted_59 = {
  key: 1,
  class: "flex-col justify-start items center"
}
const _hoisted_60 = { class: "text-sm" }
const _hoisted_61 = { class: "flex justify-start mt-4 flex-wrap" }
const _hoisted_62 = { class: "flex justify-start mt-4" }
const _hoisted_63 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_toggle = _resolveComponent("app-toggle")!
  const _component_card_list_item = _resolveComponent("card-list-item")!
  const _component_app_radio_button = _resolveComponent("app-radio-button")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_mail_preview_content = _resolveComponent("mail-preview-content")!
  const _component_bee_editor = _resolveComponent("bee-editor")!
  const _component_card_group = _resolveComponent("card-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_section, { class: "py-3 bg-light-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_app_button, {
          "button-style": "breadcrumbStart",
          onClick: _ctx.goToOverview
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("pages.automation.overview")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_app_button, { "button-style": "breadcrumb" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.automation.name), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, { class: "pt-5 pb-10 bg-light-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              innerHTML: _ctx.automation.icon,
              class: "automation-header-icon-wrapper mr-3"
            }, null, 8, _hoisted_3),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("pages.automations." + _ctx.automation.type + ".name")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isSaving)
              ? (_openBlock(), _createBlock(_component_app_icon, {
                  key: 0,
                  name: "Refresh",
                  class: "mr-1 animate-spin",
                  size: "5"
                }))
              : _createCommentVNode("", true),
            (!_ctx.enabled)
              ? (_openBlock(), _createBlock(_component_app_button, {
                  key: 1,
                  class: "ml-5",
                  disabled: !_ctx.canActivate,
                  "disabled-style": "lighter",
                  onClick: _ctx.activateAutomation
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("pages.automation.activate")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_app_icon, {
                    name: "CheckCircle",
                    class: "text-green-400 mr-1",
                    size: "5"
                  }),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("pages.automation.activeSince")) + " " + _toDisplayString(_ctx.activeSince), 1),
                  _createVNode(_component_app_toggle, {
                    active: true,
                    "onUpdate:active": _ctx.deactivateAutomation,
                    class: "ml-5"
                  }, null, 8, ["onUpdate:active"])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("pages.automations." + _ctx.automation.type + ".description")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, { class: "py-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_card_group, {
          title: _ctx.$t('pages.mail.configuration')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.automation.audience'),
              status: "success",
              class: "mb-5 text-sm",
              "action-disabled": true,
              disabled: !!_ctx.activeItem && _ctx.activeItem !== 'audience'
            }, {
              default: _withCtx(() => [
                (_ctx.activeItem !== 'receiver')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_app_icon, {
                        name: "Users",
                        size: "5",
                        class: "mr-1"
                      }),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("pages.automation.segment")) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.automation.segment.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title", "disabled"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.automation.automationActions'),
              status: "success",
              active: _ctx.activeItem === 'wait',
              class: "mb-5 text-sm",
              disabled: !!_ctx.activeItem && _ctx.activeItem !== 'wait',
              "show-actions": false,
              onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeItem = 'wait'))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("pages.automation.trigger")), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.automation.triggerText || "n/a"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("pages.automation.wait")), 1),
                          (_ctx.activeItem !== 'wait')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.waitQuantity >= 24
                                                    ? _ctx.waitQuantity / 24
                                                    : _ctx.waitQuantity) + " " + _toDisplayString(_ctx.waitPeriodLabel), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t(
                                                        "pages.automation.waitText"
                                                    )), 1),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_app_radio_button, {
                                    modelValue: _ctx.waitPeriod,
                                    "onUpdate:modelValue": [
                                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.waitPeriod) = $event)),
                                      
                                                        _ctx.setWaitQuantityData
                                                    
                                    ],
                                    value: "hours",
                                    label: _ctx.$t('general.hours'),
                                    class: "mb-3"
                                  }, null, 8, ["modelValue", "label", "onUpdate:modelValue"]),
                                  _createVNode(_component_app_radio_button, {
                                    modelValue: _ctx.waitPeriod,
                                    "onUpdate:modelValue": [
                                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.waitPeriod) = $event)),
                                      
                                                        _ctx.setWaitQuantityData
                                                    
                                    ],
                                    value: "days",
                                    label: _ctx.$t('general.days')
                                  }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                                ]),
                                _createVNode(_component_app_select, {
                                  modelValue: _ctx.waitQuantityData,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.waitQuantityData) = $event)),
                                  options: _ctx.waitOptions,
                                  class: "mb-8"
                                }, null, 8, ["modelValue", "options"]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_app_button, { onClick: _ctx.saveWaitQuantity }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("general.save")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_app_button, {
                                    "button-style": "transparentUnderline",
                                    onClick: _ctx.cancelWaitQuantity
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]))
                        ]),
                        (_ctx.activeItem !== 'wait')
                          ? (_openBlock(), _createBlock(_component_app_button, {
                              key: 0,
                              "button-style": "white",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeItem = 'wait'))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("general.edit")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("pages.automation.sendMessage")), 1),
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.subject || "-"), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title", "active", "disabled"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.sender'),
              status: _ctx.activeItem === 'sender' ? 'muted' : 'success',
              active: _ctx.activeItem === 'sender',
              class: "mb-5 text-sm",
              disabled: !!_ctx.activeItem && _ctx.activeItem !== 'sender',
              "show-actions": _ctx.activeItem !== 'sender',
              onEdit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeItem = 'sender'))
            }, {
              default: _withCtx(() => [
                (_ctx.activeItem !== 'sender')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_ctx.fromName) + " ", 1),
                      (_ctx.fromAddress)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("-")
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.fromAddress), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("pages.mail.senderHeader")), 1),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.fromName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fromName) = $event)),
                          label: _ctx.$t('pages.mail.name'),
                          limit: 100,
                          class: "w-100 mr-6"
                        }, null, 8, ["modelValue", "label"]),
                        _createVNode(_component_app_select, {
                          modelValue: _ctx.fromAddress,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fromAddress) = $event)),
                          label: _ctx.$t('pages.mail.email'),
                          options: _ctx.emailOptions,
                          class: "w-80"
                        }, null, 8, ["modelValue", "label", "options"])
                      ]),
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("pages.mail.senderText")), 1),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_app_button, { onClick: _ctx.saveEmail }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("general.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_app_button, {
                          "button-style": "transparentUnderline",
                          onClick: _ctx.resetEmail
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["title", "status", "active", "disabled", "show-actions"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.subject'),
              status: _ctx.subjectStatus,
              active: _ctx.activeItem === 'subject',
              class: "mb-5 text-sm",
              disabled: !!_ctx.activeItem && _ctx.activeItem !== 'subject',
              "show-actions": _ctx.activeItem !== 'subject',
              onEdit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeItem = 'subject'))
            }, {
              default: _withCtx(() => [
                (_ctx.activeItem !== 'subject')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.subject || "–"), 1),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("pages.mail.preheader")) + " " + _toDisplayString(_ctx.preheaderText || "–"), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("pages.mail.subjectHeader")), 1),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.subject,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.subject) = $event)),
                          label: `${_ctx.$t('pages.mail.subject')} *`,
                          status: _ctx.subjectInputStatus,
                          description: _ctx.subjectInputDescription,
                          counter: 100,
                          class: "w-100 mb-4"
                        }, null, 8, ["modelValue", "label", "status", "description"]),
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.preheaderText,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.preheaderText) = $event)),
                          label: _ctx.$t('pages.mail.preheaderText'),
                          status: _ctx.preheaderTextInputStatus,
                          description: _ctx.preheaderTextInputDescription,
                          counter: 100,
                          limit: 150,
                          class: "w-100"
                        }, null, 8, ["modelValue", "label", "status", "description"])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_app_button, { onClick: _ctx.saveEmail }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("general.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_app_button, {
                          "button-style": "transparentUnderline",
                          onClick: _ctx.resetEmail
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["title", "status", "active", "disabled", "show-actions"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.content'),
              status: _ctx.html.length ? 'success' : 'danger',
              class: "mb-5 text-sm",
              disabled: !!_ctx.activeItem && _ctx.activeItem !== 'editor',
              onEdit: _ctx.editTemplate
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_mail_preview_content, { html: _ctx.html }, null, 8, ["html"]),
                  _withDirectives(_createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_app_button, {
                      class: "pt-1",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendTestMail(_ctx.emailId))),
                      "button-style": "transparentUnderline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("components.mails.editContent.sendTestMail")), 1)
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.html.length]
                  ])
                ]),
                _createVNode(_component_bee_editor, {
                  "template-content": _ctx.templateContent,
                  "template-name": _ctx.templateName,
                  "template-key": _ctx.templateKey,
                  "template-type": _ctx.templateType,
                  "send-test-mail-enabled": true,
                  "save-as-template-enabled": true,
                  "switch-template-enabled": true,
                  "email-id": _ctx.emailId,
                  "edit-name-enabled": false,
                  onSave: _ctx.saveTemplateContent,
                  onExit: _ctx.exitEditor
                }, null, 8, ["template-content", "template-name", "template-key", "template-type", "email-id", "onSave", "onExit"])
              ]),
              _: 1
            }, 8, ["title", "status", "disabled", "onEdit"]),
            _createVNode(_component_card_list_item, {
              title: _ctx.$t('pages.mail.utmTitle'),
              status: _ctx.activeItem === 'umt' ? 'muted' : 'success',
              active: _ctx.activeItem === 'utm',
              class: "mb-5 text-sm",
              disabled: !!_ctx.activeItem && _ctx.activeItem !== 'utm',
              "show-actions": _ctx.activeItem !== 'utm',
              onEdit: _cache[16] || (_cache[16] = ($event: any) => (_ctx.activeItem = 'utm'))
            }, {
              default: _withCtx(() => [
                (_ctx.activeItem !== 'utm')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      (_ctx.utmSource)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("pages.mail.source")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.utmSource), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.utmMedium)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                            _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("pages.mail.medium")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.utmMedium), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.utmCampaign)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("pages.mail.name")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.utmCampaign), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.utmContent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t("pages.mail.content")) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.utmContent), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("pages.mail.utmHeader")), 1),
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.utmSource,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.utmSource) = $event)),
                          label: `${_ctx.$t('pages.mail.source')} *`,
                          class: "w-100 mr-6"
                        }, null, 8, ["modelValue", "label"]),
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.utmMedium,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.utmMedium) = $event)),
                          label: _ctx.$t('pages.mail.medium'),
                          class: "w-100"
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.utmCampaign,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.utmCampaign) = $event)),
                          label: _ctx.$t('pages.mail.name'),
                          class: "w-100 mr-6"
                        }, null, 8, ["modelValue", "label"]),
                        _createVNode(_component_app_input, {
                          modelValue: _ctx.utmContent,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.utmContent) = $event)),
                          label: _ctx.$t('pages.mail.content'),
                          class: "w-100"
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_app_button, { onClick: _ctx.saveEmail }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("general.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_app_button, {
                          "button-style": "transparentUnderline",
                          onClick: _ctx.resetEmail
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["title", "status", "active", "disabled", "show-actions"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    })
  ], 64))
}